import Popper from 'popper.js';
import { merge } from 'lodash-es';

const DEFAULT_OPTIONS = {
  placement: 'top',
  modifiers: {
    arrow: {
      enabled: false,
    },
    preventOverflow: {
      escapeWithReference: true,
    },
  },
};

export default function (referenceElement, popoverElement, options = {}) {
  // eslint-disable-next-line prototype-pollution-security-rules/detect-merge-objects
  const finalOptions = merge({}, DEFAULT_OPTIONS, options);

  return new Popper(referenceElement, popoverElement, finalOptions);
}
